import { render } from "./TitleBar.vue?vue&type=template&id=188d268c&scoped=true&ts=true"
import script from "./TitleBar.vue?vue&type=script&lang=ts"
export * from "./TitleBar.vue?vue&type=script&lang=ts"

import "./TitleBar.vue?vue&type=style&index=0&id=188d268c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188d268c"]])

export default __exports__